export default ({ get, put, post, checkStatus, toJSON }) => ({
  getChamps: () => get(`universe/v1/champs`).then(checkStatus).then(toJSON),
  getProfileChamps: () =>
    get(`universe/v1/classroom_champs`).then(checkStatus).then(toJSON),
  levelUpChamp: () =>
    put(`universe/v1/classroom_champs/level_up`).then(checkStatus).then(toJSON),
  chooseNewChamp: (id) =>
    post(`universe/v1/classroom_champs`, {
      body: {
        classroomChamp: {
          champId: id,
        },
      },
    }).then(checkStatus),
  resetChampionsProgress: (id) =>
    post(`universe/v1/classroom_champs/reset_all`, {
      body: {
        classroomChamp: {
          champId: id,
        },
      },
    }).then(checkStatus),
});
